import { Box, Stack, Tooltip } from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { formatLabel } from "../../form/utils";
import InfoIcon from "../../components/icons/InfoIcon";

export const CellHeader = ({
  name = "",
  unit = undefined,
  description = "",
  inlineEditable,
}) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'
      justifyContent='flex-start'
    >
      {formatLabel({ label: name, unit })}
      {inlineEditable && (
        <ModeEditOutlineOutlinedIcon
          fontSize='small'
          color='disabled'
          sx={{ ml: 1 }}
          data-testid='inline-edit-icon'
        />
      )}
      {description && (
        <Tooltip
          title={description}
          arrow
          placement='top'
          enterDelay={200}
          leaveDelay={200}
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: "0.875rem",
                maxWidth: 300,
                lineHeight: 1.5,
              },
            },
          }}
        >
          <Box
            component='span'
            data-testid='info-tooltip-trigger'
            aria-label='Column information'
            sx={{
              display: "inline-flex",
              cursor: "help",
              alignItems: "center",
            }}
          >
            <InfoIcon />
          </Box>
        </Tooltip>
      )}
    </Stack>
  );
};
